// Maly badge v header — zobrazuje online/offline + pocet pending eventu.
// Pri klikuti -> manual sync trigger (pro debug / pokud auto nesplnil).

import { useSyncStore } from "../store/syncStore";

export function NetworkBadge() {
  const { online, pendingCount, syncing, syncNow } = useSyncStore();

  const handleClick = () => {
    void syncNow();
  };

  return (
    <button
      onClick={handleClick}
      title={
        syncing
          ? `Synchronizace běží… (${pendingCount} čekajících)`
          : online
            ? `Online${pendingCount > 0 ? ` · ${pendingCount} čeká na sync (klik = sync teď)` : ""}`
            : `Offline · ${pendingCount} čeká na obnovu připojení`
      }
      style={{
        background: "transparent",
        border: "none",
        padding: "0 8px",
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        color: "var(--soft)",
        fontSize: 12,
      }}
    >
      <span
        style={{
          width: 8,
          height: 8,
          borderRadius: 4,
          background: syncing ? "var(--brass)" : online ? "var(--ok)" : "var(--bad)",
          display: "inline-block",
          animation: syncing ? "pulse 1s infinite" : "none",
        }}
      />
      {pendingCount > 0 && (
        <span style={{ fontWeight: 600, fontSize: 11 }}>{pendingCount}</span>
      )}
    </button>
  );
}
